{
    "Accessibility Menu": "Menu Aksesibilitas",
    "Reset settings": "Atur Ulang Pengaturan",
    "Close": "Tutup",
    "Content Adjustments": "Penyesuaian Konten",
    "Adjust Font Size": "Sesuaikan Ukuran Font",
    "Highlight Title": "Sorot Judul",
    "Highlight Links": "Sorot Tautan",
    "Readable Font": "Font Mudah Dibaca",
    "Color Adjustments": "Penyesuaian Warna",
    "Dark Contrast": "Kontras Gelap",
    "Light Contrast": "Kontras Terang",
    "High Contrast": "Kontras Tinggi",
    "High Saturation": "Saturasi Tinggi",
    "Low Saturation": "Saturasi Rendah",
    "Monochrome": "Monokrom",
    "Protanopia": "Protanopia",
    "Deuteranopia": "Deuteranopia",
    "Tritanopia": "Tritanopia",
    "Visual & Navigation Aids": "Alat Bantu Visual dan Navigasi",
    "Additional Tools": "Alat Tambahan",
    "Reading Guide": "Panduan Membaca",
    "Stop Animations": "Hentikan Animasi",
    "Big Cursor": "Kursor Besar",
    "Screen Reader": "Pembaca Layar",
    "Hide Images": "Sembunyikan Gambar",
    "Image Tooltips": "Keterangan Gambar",
    "Page Structure": "Struktur Halaman",
    "Super Focus": "Super Fokus",
    "Magnifier": "Kaca Pembesar",
    "Increase Font Size": "Perbesar Ukuran Font",
    "Decrease Font Size": "Perkecil Ukuran Font",
    "Letter Spacing": "Jarak Huruf",
    "Line Height": "Tinggi Baris",
    "Font Weight": "Ketebalan Font",
    "Dyslexia Font": "Font Disleksia",
    "Language": "Bahasa",
    "Open Accessibility Menu": "Buka menu aksesibilitas",
    "Accessibility Profiles": "Profil Aksesibilitas",
    "Seizure Safe Profile": "Profil Aman untuk Kejang",
    "Stops animations and reduces color saturation.": "Menghentikan animasi dan mengurangi saturasi warna.",
    "Blind Profile": "Profil untuk Tunanetra",
    "Activates the screen reader for auditory navigation.": "Mengaktifkan pembaca layar untuk navigasi auditif.",
    "Visually Impaired Profile": "Profil untuk Tunawicara",
    "Enhances contrast and readability for low vision.": "Meningkatkan kontras dan keterbacaan untuk penglihatan rendah.",
    "ADHD Friendly Profile": "Profil Ramah ADHD",
    "Reduces distractions for better focus.": "Mengurangi gangguan untuk fokus yang lebih baik.",
    "Cognitive & Learning Profile": "Profil Kognitif dan Pembelajaran",
    "Helpful tools for reading and comprehension.": "Alat berguna untuk membaca dan pemahaman.",
    "Motor Impaired Profile": "Profil untuk Disabilitas Motorik",
    "Optimizes the site for keyboard-only navigation.": "Mengoptimalkan situs untuk navigasi hanya menggunakan keyboard.",
    "Headings": "Judul",
    "Landmarks": "Penanda",
    "Links": "Tautan",
    "Focus element": "Fokus elemen",
    "Visit link": "Kunjungi tautan"
}